"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TopicHeader = _interopRequireDefault(require("../shared/TopicHeader"));

var _TopicFooter = _interopRequireDefault(require("../shared/TopicFooter"));

var _common = require("@insided/shared/utils/common");

var _TopicBody = _interopRequireDefault(require("./TopicBody"));

var _permissions = require("@insided/deprecated-preact-components/utils/permissions");

var _HubAI = require("@insided/shared/modules/HubAI");

var _menuOptions = require("../shared/TopicHeader/menuOptions");

var _ReportContentModal = _interopRequireDefault(require("../Post/ReportContentModal"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Editor = require("../shared/Editor");

var _Content = require("@insided/destination/modules/Content");

var _TopicHeaderLabel = _interopRequireDefault(require("../V2/Topic/TopicHeader/TopicHeaderLabel"));

var _TopicHeaderMetaInfo = _interopRequireDefault(require("../V2/Topic/TopicHeader/TopicHeaderMetaInfo"));

var _TopicPublicTags = _interopRequireDefault(require("@insided/deprecated-preact-components/topic-list-view/TopicPublicTags"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _MarkAsSpamModal = _interopRequireDefault(require("../Post/MarkAsSpamModal"));

var _TrashModal = _interopRequireDefault(require("../Post/TrashModal"));

var _topicService = require("@insided/shared/services/topicService");

var _topicService2 = require("../../TopicList/services/topicService");

var _contentType = require("@insided/shared/utils/contentType");

var _SubtleButton = _interopRequireDefault(require("@insided/shared/uikit/SubtleButton"));

var _Edit = _interopRequireDefault(require("@insided/destination/icons/Edit"));

var _ExternalLink = _interopRequireDefault(require("@insided/destination/icons/ExternalLink"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _CopyLink = _interopRequireDefault(require("@insided/destination/icons/CopyLink"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _Profile = _interopRequireDefault(require("../V2/Shared/Profile"));

var _IpDetails = _interopRequireDefault(require("../V2/Shared/IpDetails"));

var _NotifyAuthor = _interopRequireDefault(require("../V2/Shared/NotifyAuthor"));

var _ResolveModal = _interopRequireDefault(require("../Post/ResolveModal"));

var _ConfigContext = require("@insided/shared/services/ConfigContext");

var _ChangeAuthorModal = _interopRequireDefault(require("@insided/control/modules/ContentModeration/TopicModeration/TopicHeader/ChangeAuthorModal"));

var _spamService = require("@insided/control/modules/ContentModeration/TopicModeration/services/spamService");

var _MarkAsNotSpamModal = _interopRequireDefault(require("@insided/control/modules/ContentModeration/TopicModeration/MarkAsSpam/MarkAsNotSpamModal"));

var _CopyTopicModal = _interopRequireDefault(require("@insided/control/modules/ContentModeration/TopicModeration/TopicHeader/CopyTopicModal"));

var _MergeIdeaModal = _interopRequireDefault(require("@insided/control/modules/ContentModeration/TopicModeration/TopicHeader/MergeIdeaModal"));

var _ConvertTopicModal = _interopRequireDefault(require("@insided/control/modules/ContentModeration/TopicModeration/TopicHeader/ConvertTopicModal"));

var _MoveToExistingTopicModal = _interopRequireDefault(require("@insided/control/modules/ContentModeration/TopicModeration/MoveToTopic/MoveToExistingTopicModal"));

var _categoryService = require("@insided/control/modules/Categories/categoryService");

var _topicService3 = require("@insided/control/modules/ContentModeration/TopicModeration/services/topicService");

var _unifiedService = require("@insided/control/modules/ContentModeration/TopicModeration/services/unifiedService");

var _categories = require("@insided/shared/utils/categories");

var _BookmarkOutline = _interopRequireDefault(require("@insided/shared/icons/BookmarkOutline"));

var _BookmarkOutlineOff = _interopRequireDefault(require("@insided/shared/icons/BookmarkOutlineOff"));

var _PinnedAndBestAnswerSection = _interopRequireDefault(require("../V2/PinnedAndBestAnswerSection"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicWrapper = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicWrapper, _Component);

  var _super = _createSuper(TopicWrapper);

  function TopicWrapper(props) {
    var _votes, _this$props$topic$pol, _this$props$topic$pol2, _this$props$topic$att, _this$props$topic$sti;

    var _this;

    (0, _classCallCheck2.default)(this, TopicWrapper);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "config", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      tags: _this.props.topic.tags || [],
      alert: undefined,
      showReportContentModal: false,
      showEditor: false,
      pollSelectionLoading: false,
      pollVotes: (_votes = (_this$props$topic$pol = _this.props.topic.poll) === null || _this$props$topic$pol === void 0 ? void 0 : _this$props$topic$pol.votes) !== null && _votes !== void 0 ? _votes : {},
      answeredPoll: (_this$props$topic$pol2 = _this.props.topic.pollVotedByUser) !== null && _this$props$topic$pol2 !== void 0 ? _this$props$topic$pol2 : false,
      showMarkAsSpamModal: false,
      showTrashModal: false,
      showChangeAuthorModal: false,
      updatedTopicContent: _this.props.topic.content,
      poll: _this.props.topic.poll,
      updatedAttachments: (_this$props$topic$att = _this.props.topic.attachments) !== null && _this$props$topic$att !== void 0 ? _this$props$topic$att : [],
      isHovered: false,
      showReportContentResolveModal: false,
      showUnmarkMarkAsSpamModal: false,
      sticky: (_this$props$topic$sti = _this.props.topic.sticky) !== null && _this$props$topic$sti !== void 0 ? _this$props$topic$sti : false,
      showCopyTopicModal: false,
      categoriesV2: null,
      showMergeIdeaModal: false,
      ideaStatuses: [],
      showConvertModal: false,
      convertToContentType: null,
      showMoveToExistingTopicModal: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseEnter", function () {
      _this.setState({
        isHovered: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseLeave", function () {
      _this.setState({
        isHovered: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTagsChange", function (newTags) {
      _this.setState({
        tags: newTags
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleEditCancel", function () {
      var _this$props$topic$att2;

      _this.setState({
        showEditor: false,
        updatedTopicContent: _this.props.topic.content,
        updatedAttachments: (_this$props$topic$att2 = _this.props.topic.attachments) !== null && _this$props$topic$att2 !== void 0 ? _this$props$topic$att2 : []
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleEditSuccess", function (content, attachments) {
      _this.setState({
        showEditor: false,
        updatedTopicContent: content !== null && content !== void 0 ? content : _this.props.topic.content,
        updatedAttachments: attachments !== null && attachments !== void 0 ? attachments : _this.props.topic.attachments
      });

      window.location.reload();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPollUpdate", function (newValue) {
      if (_this.state.poll) {
        var poll = _this.state.poll;

        var newPoll = _objectSpread(_objectSpread({}, poll), newValue);

        _this.setState({
          poll: newPoll
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handlePollAnswer", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(selectedOption) {
        var _this$props, _this$props$topic, id, contentType, currentUser, pollVotes, res;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, _this$props$topic = _this$props.topic, id = _this$props$topic.id, contentType = _this$props$topic.contentType, currentUser = _this$props.currentUser;

                if (currentUser !== null && currentUser !== void 0 && currentUser.id) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                pollVotes = _this.state.pollVotes;

                _this.setState({
                  pollSelectionLoading: true
                });

                _context.next = 7;
                return _axios.default.post("/community/api/".concat(contentType, "s/").concat(id, "/votePoll"), {
                  selectedOption: selectedOption
                });

              case 7:
                res = _context.sent;

                if (res.status === 204) {
                  _this.setState({
                    pollSelectionLoading: false,
                    answeredPoll: true,
                    pollVotes: _objectSpread(_objectSpread({}, pollVotes), {}, (0, _defineProperty2.default)({}, currentUser.id, selectedOption))
                  });
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleEditClick", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _this$props2, isPostTranslated, onDisplayOriginal;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, isPostTranslated = _this$props2.isPostTranslated, onDisplayOriginal = _this$props2.onDisplayOriginal;

              if (!(isPostTranslated && onDisplayOriginal)) {
                _context2.next = 4;
                break;
              }

              _context2.next = 4;
              return onDisplayOriginal();

            case 4:
              _this.setState({
                showEditor: true
              });

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleShowAlert", function (type, message) {
      _this.setState({
        alert: {
          type: type,
          message: typeof message === 'string' ? (0, _preact.h)(_phrase.default, {
            p: message
          }) : message !== null && message !== void 0 ? message : (0, _preact.h)(_phrase.default, {
            p: "topic_view.reported_content_modal.error"
          })
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleReportedContentModal", function (show) {
      _this.setState({
        showReportContentModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showMarkAsSpamModal", function (show) {
      _this.setState({
        showMarkAsSpamModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleUnMarkAsSpamModal", function (show) {
      _this.setState({
        showUnmarkMarkAsSpamModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showTrashModal", function (show) {
      _this.setState({
        showTrashModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showChangeAuthorModal", function (show) {
      _this.setState({
        showChangeAuthorModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleToggleSticky", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var topic, topicId, contentType, sticky, newSticky;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              topic = _this.props.topic;
              topicId = topic.id, contentType = topic.contentType;
              sticky = _this.state.sticky;
              newSticky = !sticky;
              _context3.prev = 4;
              _context3.next = 7;
              return (0, _topicService.toggleSticky)(contentType, Number(topicId), newSticky);

            case 7:
              _this.setState({
                sticky: newSticky
              });

              _this.handleShowAlert('success', newSticky ? 'Topic has been marked as sticky.' : 'Topic has been unmarked as sticky.');

              _context3.next = 14;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](4);

              _this.handleShowAlert('error', 'An error occurred while updating sticky state.');

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[4, 11]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleReportedContentResolveModal", function (show) {
      _this.setState({
        showReportContentResolveModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMoveToExistingTopic", function (show) {
      _this.setState({
        showMoveToExistingTopicModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDuplicateTopic", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var categories;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (_this.state.categoriesV2) {
                _context4.next = 13;
                break;
              }

              _context4.prev = 1;
              _context4.next = 4;
              return (0, _categoryService.getCategoriesList)([(0, _categories.getTypeFromModuleName)(_categories.MODULE.COMMUNITY), (0, _categories.getTypeFromModuleName)(_categories.MODULE.KNOWLEDGE_BASE), (0, _categories.getTypeFromModuleName)(_categories.MODULE.GROUPS)]);

            case 4:
              categories = _context4.sent;

              _this.setState({
                categoriesV2: categories,
                showCopyTopicModal: true
              });

              _context4.next = 11;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](1);

              _this.handleShowAlert('error', 'Failed to load categories');

            case 11:
              _context4.next = 14;
              break;

            case 13:
              _this.setState({
                showCopyTopicModal: true
              });

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showCopyTopicModal", function (show) {
      _this.setState({
        showCopyTopicModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMergeIdea", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      var ideaStatuses;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(_this.state.ideaStatuses.length === 0)) {
                _context5.next = 13;
                break;
              }

              _context5.prev = 1;
              _context5.next = 4;
              return (0, _topicService3.getIdeaStatuses)();

            case 4:
              ideaStatuses = _context5.sent;

              _this.setState({
                ideaStatuses: ideaStatuses,
                showMergeIdeaModal: true
              });

              _context5.next = 11;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](1);

              _this.handleShowAlert('error', 'Failed to load idea statuses');

            case 11:
              _context5.next = 14;
              break;

            case 13:
              _this.setState({
                showMergeIdeaModal: true
              });

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showMergeIdeaModal", function (show) {
      _this.setState({
        showMergeIdeaModal: show
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showConvertModal", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(toContentType) {
        var topic, pinnedReply, reported, reportedReplies;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                topic = _this.props.topic;
                pinnedReply = topic.pinnedReply, reported = topic.reported;

                if (!pinnedReply) {
                  _context6.next = 5;
                  break;
                }

                _this.handleShowAlert('error', "It's not possible to convert a topic with a pinned reply. Please first unpin the reply and try again.");

                return _context6.abrupt("return");

              case 5:
                if (!reported) {
                  _context6.next = 8;
                  break;
                }

                _this.handleShowAlert('error', "It's not possible to convert a topic in reported state. Please resolve the topic and try again.");

                return _context6.abrupt("return");

              case 8:
                _context6.prev = 8;
                _context6.next = 11;
                return (0, _unifiedService.getReportedReplies)(Number(topic.publicId));

              case 11:
                reportedReplies = _context6.sent;

                if (!(reportedReplies.total > 0)) {
                  _context6.next = 15;
                  break;
                }

                _this.handleShowAlert('error', "It's not possible to convert a topic with a reported reply. Please resolve the reply and try again.");

                return _context6.abrupt("return");

              case 15:
                _context6.next = 20;
                break;

              case 17:
                _context6.prev = 17;
                _context6.t0 = _context6["catch"](8);
                console.error('Failed to check reported replies:', _context6.t0);

              case 20:
                _this.setState({
                  showConvertModal: true,
                  convertToContentType: toContentType
                });

              case 21:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[8, 17]]);
      }));

      return function (_x2) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hideConvertModal", function () {
      _this.setState({
        showConvertModal: false,
        convertToContentType: null
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChangeAuthor", function () {
      window.location.reload();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getTopicActionItems", function (contentType) {
      var isBugContentTypeEnabled = _common.common.isModuleActive('bugContentType');

      switch (contentType) {
        case _contentType.CONTENT_TYPE_QUESTION:
          return [(0, _menuOptions.getMoveToExistingTopicMenuItem)(function () {
            return _this.handleMoveToExistingTopic(true);
          }), (0, _menuOptions.getConvertToConversationMenuItem)(function () {
            return _this.showConvertModal(_contentType.CONTENT_TYPE_CONVERSATION);
          }, isBugContentTypeEnabled), (0, _menuOptions.getConvertToIdeaMenuItem)(function () {
            return _this.showConvertModal(_contentType.CONTENT_TYPE_IDEA);
          })];

        case _contentType.CONTENT_TYPE_CONVERSATION:
          return [(0, _menuOptions.getMoveToExistingTopicMenuItem)(function () {
            return _this.handleMoveToExistingTopic(true);
          }), (0, _menuOptions.getDuplicateTopicMenuItem)(_this.handleDuplicateTopic), (0, _menuOptions.getConvertToQuestionMenuItem)(function () {
            return _this.showConvertModal(_contentType.CONTENT_TYPE_QUESTION);
          }), (0, _menuOptions.getConvertToArticleMenuItem)(function () {
            return _this.showConvertModal(_contentType.CONTENT_TYPE_ARTICLE);
          }), (0, _menuOptions.getConvertToIdeaMenuItem)(function () {
            return _this.showConvertModal(_contentType.CONTENT_TYPE_IDEA);
          })];

        case _contentType.CONTENT_TYPE_ARTICLE:
          return [(0, _menuOptions.getConvertToConversationMenuItem)(function () {
            return _this.showConvertModal(_contentType.CONTENT_TYPE_CONVERSATION);
          }, isBugContentTypeEnabled), (0, _menuOptions.getConvertToProductUpdateMenuItem)(function () {
            return _this.showConvertModal(_contentType.CONTENT_TYPE_PRODUCT_UPDATE);
          })];

        case _contentType.CONTENT_TYPE_IDEA:
          return [(0, _menuOptions.getMergeIdeaMenuItem)(_this.handleMergeIdea), (0, _menuOptions.getConvertToQuestionMenuItem)(function () {
            return _this.showConvertModal(_contentType.CONTENT_TYPE_QUESTION);
          }), (0, _menuOptions.getConvertToConversationMenuItem)(function () {
            return _this.showConvertModal(_contentType.CONTENT_TYPE_CONVERSATION);
          }, isBugContentTypeEnabled)];

        case _contentType.CONTENT_TYPE_PRODUCT_UPDATE:
          return [];

        default:
          return [];
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMarkAsSpam", /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(banUser) {
        var _this$props3, topic, displayExtendedActions, topicId, contentType;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this$props3 = _this.props, topic = _this$props3.topic, displayExtendedActions = _this$props3.displayExtendedActions;
                topicId = topic.id, contentType = topic.contentType;
                _context7.prev = 2;

                if (!displayExtendedActions) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 6;
                return (0, _spamService.markPostsAsSpam)([{
                  id: Number(topicId),
                  contentType: contentType
                }], banUser);

              case 6:
                _context7.next = 10;
                break;

              case 8:
                _context7.next = 10;
                return (0, _topicService.markTopicAsSpam)(contentType, Number(topicId));

              case 10:
                _this.handleShowAlert('success', 'frontend_moderation.topic_marked_as_spam');

                _this.showMarkAsSpamModal(false);

                window.location.reload();
                _context7.next = 19;
                break;

              case 15:
                _context7.prev = 15;
                _context7.t0 = _context7["catch"](2);

                _this.handleShowAlert('error', 'frontend_moderation.error_marking_topic_as_spam');

                _this.showMarkAsSpamModal(false);

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[2, 15]]);
      }));

      return function (_x3) {
        return _ref7.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleUnmarkAsSpam", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
      var topic, topicId, contentType;
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              topic = _this.props.topic;
              topicId = topic.id, contentType = topic.contentType;
              _context8.prev = 2;
              _context8.next = 5;
              return (0, _spamService.markPostsAsNotSpam)([{
                id: Number(topicId),
                contentType: contentType
              }]);

            case 5:
              _this.handleShowAlert('success', 'The topic has been unmarked as spam.');

              window.location.reload();
              _context8.next = 12;
              break;

            case 9:
              _context8.prev = 9;
              _context8.t0 = _context8["catch"](2);

              _this.handleShowAlert('error', 'An error occurred while unmarking the topic as spam');

            case 12:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[2, 9]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTrash", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
      var topic, topicId, contentType;
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              topic = _this.props.topic;
              topicId = topic.id, contentType = topic.contentType;
              _context9.prev = 2;
              _context9.next = 5;
              return (0, _topicService.toggleTrashed)(contentType, Number(topicId), true);

            case 5:
              _this.handleShowAlert('success', 'frontend_moderation.topic_trashed');

              _this.showTrashModal(false);

              window.location.reload();
              _context9.next = 14;
              break;

            case 10:
              _context9.prev = 10;
              _context9.t0 = _context9["catch"](2);

              _this.handleShowAlert('error', 'frontend_moderation.error_trashing_topic');

              _this.showTrashModal(false);

            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[2, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCloseTopicToggle", /*#__PURE__*/function () {
      var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(e) {
        var topic, topicId, contentType, closed;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                e.preventDefault();
                topic = _this.props.topic;
                topicId = topic.id, contentType = topic.contentType, closed = topic.closed;
                _context10.next = 5;
                return (0, _topicService2.onChangeCloseTopicForReplies)(e, Number(topicId), closed, contentType, _this.handleShowAlert);

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x4) {
        return _ref10.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCopyLink", /*#__PURE__*/function () {
      var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(e) {
        var permalink;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                e.stopPropagation();
                _context11.prev = 1;
                permalink = (0, _Content.getPermalink)();
                _context11.next = 5;
                return navigator.clipboard.writeText(permalink);

              case 5:
                _this.handleShowAlert('success', 'frontend_moderation.link_copied_to_clipboard');

                _context11.next = 11;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](1);

                _this.handleShowAlert('error', 'frontend_moderation.failed_to_copy_link_to_clipboard');

              case 11:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[1, 8]]);
      }));

      return function (_x5) {
        return _ref11.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderEditor", function () {
      var _this$props4 = _this.props,
          topic = _this$props4.topic,
          disableFileAttachments = _this$props4.disableFileAttachments,
          currentUser = _this$props4.currentUser,
          displayExtendedActions = _this$props4.displayExtendedActions;
      var topicId = topic.id,
          contentType = topic.contentType;
      var _this$state = _this.state,
          updatedTopicContent = _this$state.updatedTopicContent,
          updatedAttachments = _this$state.updatedAttachments;
      return (0, _preact.h)("div", {
        className: "post__edit, qa-topic-post-edit"
      }, (0, _preact.h)(_Editor.Editor, {
        isOpen: true,
        contentType: contentType,
        content: updatedTopicContent,
        disableFileAttachments: disableFileAttachments,
        parentTopicId: Number(topicId),
        replyId: null,
        parentReplyId: null,
        onCancel: _this.handleEditCancel,
        onSuccess: function onSuccess(content, attachments) {
          return _this.handleEditSuccess(content, attachments);
        },
        attachments: updatedAttachments,
        currentUser: currentUser,
        redirect: false,
        isTopicEdit: true,
        isControl: displayExtendedActions
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleRestore", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12() {
      var topic, topicId, contentType;
      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              topic = _this.props.topic;
              topicId = topic.id, contentType = topic.contentType;
              _context12.prev = 2;
              _context12.next = 5;
              return (0, _topicService.toggleTrashed)(contentType, Number(topicId), false);

            case 5:
              _this.handleShowAlert('success', 'The topic has been restored.');

              _this.showTrashModal(false);

              window.location.reload();
              _context12.next = 14;
              break;

            case 10:
              _context12.prev = 10;
              _context12.t0 = _context12["catch"](2);

              _this.handleShowAlert('error', 'An error occurred while restoring the topic.');

              _this.showTrashModal(false);

            case 14:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[2, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleResolve", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13() {
      var topic, topicId, contentType;
      return _regenerator.default.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              topic = _this.props.topic;
              topicId = topic.id, contentType = topic.contentType;
              _context13.prev = 2;
              _context13.next = 5;
              return (0, _topicService.resolveTopic)(contentType, Number(topicId));

            case 5:
              _this.handleShowAlert('success', 'Report(s) has been resolved.');

              _this.showTrashModal(false);

              window.location.reload();
              _context13.next = 14;
              break;

            case 10:
              _context13.prev = 10;
              _context13.t0 = _context13["catch"](2);

              _this.handleShowAlert('error', 'error');

              _this.showTrashModal(false);

            case 14:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[2, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getActionItems", function () {
      var _this$props5 = _this.props,
          destinationUrl = _this$props5.destinationUrl,
          topic = _this$props5.topic;
      var sticky = _this.state.sticky;
      var trashed = topic.trashed,
          spam = topic.spam;
      var isTrashedOrSpamTopic = trashed || spam;
      return [!isTrashedOrSpamTopic ? (0, _preact.h)(_Tooltip.default, {
        position: "center",
        top: -32,
        key: "edit",
        trigger: (0, _preact.h)(_SubtleButton.default, {
          size: "medium",
          icon: (0, _preact.h)(_Edit.default, {
            width: 16,
            height: 16,
            fill: "#5F6C7A"
          }),
          onClick: _this.handleEditClick,
          ariaLabel: "Edit"
        }),
        customClasses: "action-menu__tooltip",
        tooltipMessage: "Edit"
      }) : null, !isTrashedOrSpamTopic ? (0, _preact.h)(_Tooltip.default, {
        position: "center",
        top: -32,
        key: "sticky",
        trigger: (0, _preact.h)(_SubtleButton.default, {
          size: "medium",
          icon: sticky ? (0, _preact.h)(_BookmarkOutlineOff.default, {
            width: 16,
            height: 16
          }) : (0, _preact.h)(_BookmarkOutline.default, {
            width: 16,
            height: 16
          }),
          onClick: _this.handleToggleSticky,
          ariaLabel: sticky ? 'Unmark topic as sticky' : 'Mark topic as sticky'
        }),
        customClasses: "action-menu__tooltip",
        tooltipMessage: sticky ? 'Unmark topic as sticky' : 'Mark topic as sticky'
      }) : null, (0, _preact.h)("a", {
        key: "external-link",
        href: (0, _absoluteUrlRuntime.resolveUrl)(destinationUrl),
        target: "_blank",
        "aria-label": "External link",
        rel: "noreferrer"
      }, (0, _preact.h)(_Tooltip.default, {
        position: "center",
        top: -32,
        key: "external-link",
        trigger: (0, _preact.h)(_SubtleButton.default, {
          size: "medium",
          icon: (0, _preact.h)(_ExternalLink.default, {
            width: 16,
            height: 16,
            fill: "#5F6C7A"
          }),
          ariaLabel: "External link"
        }),
        customClasses: "action-menu__tooltip",
        tooltipMessage: "View in community"
      })), (0, _preact.h)(_Tooltip.default, {
        position: "center",
        top: -32,
        key: "link",
        trigger: (0, _preact.h)(_SubtleButton.default, {
          size: "medium",
          icon: (0, _preact.h)(_CopyLink.default, {
            size: 16,
            fill: "#5F6C7A"
          }),
          onClick: _this.handleCopyLink,
          ariaLabel: "Link"
        }),
        customClasses: "action-menu__tooltip",
        tooltipMessage: "Copy link"
      })];
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getUserActionItems", function (authorId, author, contentType, publicTopicId) {
      var _getInsidedData;

      var currentUserId = (_getInsidedData = (0, _insidedDataStorage.getInsidedData)('user')) === null || _getInsidedData === void 0 ? void 0 : _getInsidedData.userid;
      var showChangeAuthor = contentType === _contentType.CONTENT_TYPE_ARTICLE || contentType === _contentType.CONTENT_TYPE_PRODUCT_UPDATE;
      return [].concat((0, _toConsumableArray2.default)(showChangeAuthor ? [(0, _menuOptions.getChangeAuthorMenuItem)(_this.showChangeAuthorModal)] : []), (0, _toConsumableArray2.default)(authorId !== currentUserId ? [{
        title: 'Send message',
        'data-qa': 'menu-send-message',
        href: "/privateMessages/overview#conversation/".concat(authorId)
      }] : []), [{
        title: 'View profile',
        'data-qa': 'menu-view-profile',
        children: (0, _preact.h)(_Profile.default, {
          authorId: authorId.toString(),
          author: author,
          onShowAlert: _this.handleShowAlert
        })
      }, {
        title: 'View IP details',
        'data-qa': 'menu-view-ip-details',
        children: (0, _preact.h)(_IpDetails.default, {
          authorId: authorId.toString(),
          authorName: author.username,
          publicTopicId: publicTopicId
        })
      }]);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAuthorActionItems", function (topicId, publicId, contentType, publishedAt) {
      var topic = _this.props.topic;
      return [{
        title: 'Send moderation notice',
        'data-qa': 'menu-send-moderation-notice',
        children: (0, _preact.h)(_NotifyAuthor.default, {
          onShowAlert: _this.handleShowAlert,
          topicId: Number(topicId),
          contentType: contentType,
          id: String(topicId),
          topicPublicId: String(publicId),
          topicTitle: topic.title,
          publicReplyId: "",
          content: topic.content || '',
          authorId: String(topic.authorId),
          topicCreatedAt: publishedAt,
          repliedAt: ""
        })
      }];
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPostRemoveActionItems", function (spam, trashed, closed, contentType) {
      var showSpamOption = contentType !== _contentType.CONTENT_TYPE_ARTICLE && contentType !== _contentType.CONTENT_TYPE_PRODUCT_UPDATE;
      var spamHandler = spam ? _this.toggleUnMarkAsSpamModal : _this.showMarkAsSpamModal;
      var trashHandler = trashed ? _this.handleRestore : _this.showTrashModal;
      return [].concat((0, _toConsumableArray2.default)(!spam && !trashed ? [(0, _menuOptions.getCloseTopicMenuItem)(closed, _this.handleCloseTopicToggle)] : []), (0, _toConsumableArray2.default)(showSpamOption ? [(0, _menuOptions.getMarkAsSpamMenuItem)(spamHandler, spam)] : []), [(0, _menuOptions.getTrashMenuItem)(trashHandler, trashed)]);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSendToAppMenuItem", function () {
      var _authorInfo$name;

      var _ref14 = _this.config || {},
          renderSendToApp = _ref14.renderSendToApp,
          integrationStatuses = _ref14.integrationStatuses;

      if (!renderSendToApp || !integrationStatuses) return [];
      var hasEnabledIntegration = Object.values(integrationStatuses).some(Boolean);
      if (!hasEnabledIntegration) return [];
      var _this$props6 = _this.props,
          topic = _this$props6.topic,
          authors = _this$props6.authors;
      var publicId = topic.publicId,
          contentType = topic.contentType,
          title = topic.title,
          authorId = topic.authorId;
      var authorInfo = authorId && authors ? authors[authorId] : null;
      var topicContent = topic.content || '';
      return [{
        title: 'Send to app',
        'data-qa': 'menu-send-to-app',
        children: renderSendToApp({
          publicReplyId: Number(publicId),
          contentType: contentType,
          topicTitle: title,
          replyContent: topicContent,
          authorUsername: (_authorInfo$name = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.name) !== null && _authorInfo$name !== void 0 ? _authorInfo$name : 'Anonymous',
          authorUserId: String(authorId),
          onShowAlert: _this.handleShowAlert
        })
      }];
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getExtendedMenuItems", function () {
      var topic = _this.props.topic;
      var author = topic.author,
          topicId = topic.id,
          publicId = topic.publicId,
          authorId = topic.authorId,
          publishedAt = topic.publishedAt,
          contentType = topic.contentType,
          trashed = topic.trashed,
          spam = topic.spam,
          closed = topic.closed,
          reported = topic.reported;

      var userActionItems = _this.getUserActionItems(authorId, author, contentType, topic.publicId);

      var topicActionItems = _this.getTopicActionItems(contentType);

      var sendToAppItem = _this.getSendToAppMenuItem();

      var authorActionItems = _this.getAuthorActionItems(topicId, publicId, contentType, publishedAt);

      var postRemoveActionItems = _this.getPostRemoveActionItems(spam !== null && spam !== void 0 ? spam : false, trashed !== null && trashed !== void 0 ? trashed : false, closed !== null && closed !== void 0 ? closed : false, contentType);

      if (trashed) {
        var trashedAction = (0, _menuOptions.getTrashMenuItem)(_this.handleRestore, true);
        return [userActionItems, [trashedAction]];
      }

      if (spam) {
        var spamAction = (0, _menuOptions.getMarkAsSpamMenuItem)(_this.toggleUnMarkAsSpamModal, true);
        return [userActionItems, [spamAction]];
      }

      if (reported) {
        var resolveAction = (0, _menuOptions.getResolveMenuItem)(_this.toggleReportedContentResolveModal);
        return [[resolveAction], topicActionItems, sendToAppItem, userActionItems, authorActionItems, postRemoveActionItems];
      }

      return [topicActionItems, sendToAppItem, userActionItems, authorActionItems, postRemoveActionItems];
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPostActionMenuItems", function () {
      var topic = _this.props.topic;
      var publicId = topic.publicId,
          closed = topic.closed,
          contentType = topic.contentType;
      var showMarkAsSpam = contentType !== 'article' && contentType !== 'productUpdate';
      return [(0, _menuOptions.getEditMenuItem)(_this.handleEditClick)].concat((0, _toConsumableArray2.default)(closed !== undefined ? [(0, _menuOptions.getCloseTopicMenuItem)(closed, _this.handleCloseTopicToggle)] : []), [(0, _menuOptions.getCopyLinkMenuItem)(Number(publicId), _this.handleShowAlert), (0, _menuOptions.getReportMenuItem)(_this.toggleReportedContentModal)], (0, _toConsumableArray2.default)(showMarkAsSpam ? [(0, _menuOptions.getMarkAsSpamMenuItem)(_this.showMarkAsSpamModal)] : []), [(0, _menuOptions.getTrashMenuItem)(_this.showTrashModal)]);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDefaultMenuItems", function () {
      var _this$props7 = _this.props,
          topic = _this$props7.topic,
          unlimitedEditPermission = _this$props7.unlimitedEditPermission,
          topicBodyProps = _this$props7.topicBodyProps;
      var topicId = topic.id,
          publicId = topic.publicId,
          authorId = topic.authorId,
          publishedAt = topic.publishedAt;
      var showEdit = (0, _permissions.canLoginUserEditPost)(authorId, topicId, publishedAt, unlimitedEditPermission);
      var showReportContent = topicBodyProps.showReportContent;
      return [].concat((0, _toConsumableArray2.default)(showEdit ? [(0, _menuOptions.getEditMenuItem)(_this.handleEditClick)] : []), [(0, _menuOptions.getCopyLinkMenuItem)(Number(publicId), _this.handleShowAlert)], (0, _toConsumableArray2.default)(showReportContent ? [(0, _menuOptions.getReportMenuItem)(_this.toggleReportedContentModal)] : []));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getMenuItems", function () {
      var _this$props8 = _this.props,
          showPostActions = _this$props8.showPostActions,
          displayExtendedActions = _this$props8.displayExtendedActions;

      if (displayExtendedActions) {
        return _this.getExtendedMenuItems();
      }

      if (showPostActions) {
        return _this.getPostActionMenuItems();
      }

      return _this.getDefaultMenuItems();
    });
    _this.handlePollAnswer = _this.handlePollAnswer.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TopicWrapper, [{
    key: "render",
    value: function render() {
      var _authorInfo$url,
          _authorInfo$name2,
          _authorInfo$avatar,
          _authorInfo$signature,
          _authorInfo$name3,
          _authorInfo$userTitle,
          _this2 = this;

      var _this$props9 = this.props,
          topic = _this$props9.topic,
          totalReplyCount = _this$props9.totalReplyCount,
          authors = _this$props9.authors,
          currentUser = _this$props9.currentUser,
          userSubscribed = _this$props9.userSubscribed,
          topicBodyProps = _this$props9.topicBodyProps,
          _this$props9$displayE = _this$props9.displayExtendedActions,
          displayExtendedActions = _this$props9$displayE === void 0 ? false : _this$props9$displayE,
          _this$props9$usePlain = _this$props9.usePlainTextLabels,
          usePlainTextLabels = _this$props9$usePlain === void 0 ? false : _this$props9$usePlain,
          unlimitedEditPermission = _this$props9.unlimitedEditPermission,
          attachmentCdn = _this$props9.attachmentCdn,
          translatedTitle = _this$props9.translatedTitle,
          translatedTopicContent = _this$props9.translatedTopicContent,
          isTranslationInProgress = _this$props9.isTranslationInProgress,
          bestAnswer = _this$props9.bestAnswer,
          pinnedReply = _this$props9.pinnedReply;
      var _this$state2 = this.state,
          tags = _this$state2.tags,
          alert = _this$state2.alert,
          showReportContentModal = _this$state2.showReportContentModal,
          showEditor = _this$state2.showEditor,
          pollVotes = _this$state2.pollVotes,
          poll = _this$state2.poll,
          answeredPoll = _this$state2.answeredPoll,
          pollSelectionLoading = _this$state2.pollSelectionLoading,
          showTrashModal = _this$state2.showTrashModal,
          showMarkAsSpamModal = _this$state2.showMarkAsSpamModal,
          showChangeAuthorModal = _this$state2.showChangeAuthorModal,
          updatedTopicContent = _this$state2.updatedTopicContent,
          updatedAttachments = _this$state2.updatedAttachments,
          isHovered = _this$state2.isHovered,
          showReportContentResolveModal = _this$state2.showReportContentResolveModal,
          showUnmarkMarkAsSpamModal = _this$state2.showUnmarkMarkAsSpamModal,
          showCopyTopicModal = _this$state2.showCopyTopicModal,
          categoriesV2 = _this$state2.categoriesV2,
          showMergeIdeaModal = _this$state2.showMergeIdeaModal,
          ideaStatuses = _this$state2.ideaStatuses,
          showConvertModal = _this$state2.showConvertModal,
          convertToContentType = _this$state2.convertToContentType,
          sticky = _this$state2.sticky,
          showMoveToExistingTopicModal = _this$state2.showMoveToExistingTopicModal;
      var topicId = topic.id,
          publicId = topic.publicId,
          authorId = topic.authorId,
          publishedAt = topic.publishedAt,
          likedBy = topic.likedBy,
          contentType = topic.contentType,
          topLikedBy = topic.topLikedBy,
          title = topic.title,
          lastEditedAt = topic.lastEditedAt,
          reportedContent = topic.reportedContent;

      var isSocialShareEnabled = _common.common.isModuleActive('TopicSocialShare');

      var showVotes = contentType === _contentType.CONTENT_TYPE_IDEA;
      var authorInfo = authorId && authors ? authors[authorId] : null;
      var authorUrl = displayExtendedActions ? "/member/profile?userid=".concat(authorId) : (_authorInfo$url = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.url) !== null && _authorInfo$url !== void 0 ? _authorInfo$url : '';
      var author = {
        id: authorId,
        name: (_authorInfo$name2 = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.name) !== null && _authorInfo$name2 !== void 0 ? _authorInfo$name2 : 'Anonymous',
        avatar: (_authorInfo$avatar = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.avatar) !== null && _authorInfo$avatar !== void 0 ? _authorInfo$avatar : '',
        url: authorUrl,
        rank: authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.rank,
        userLevel: authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.userLevel,
        signature: (_authorInfo$signature = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.signature) !== null && _authorInfo$signature !== void 0 ? _authorInfo$signature : null,
        userName: (_authorInfo$name3 = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.name) !== null && _authorInfo$name3 !== void 0 ? _authorInfo$name3 : '',
        userTitle: (_authorInfo$userTitle = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.userTitle) !== null && _authorInfo$userTitle !== void 0 ? _authorInfo$userTitle : ''
      };
      var actionItems = displayExtendedActions ? this.getActionItems() : [];
      return (0, _preact.h)(_ConfigContext.ConfigContext.Consumer, null, function (config) {
        _this2.config = config;

        var menuItems = _this2.getMenuItems();

        return (0, _preact.h)("article", {
          className: "topic-wrapper",
          onMouseEnter: _this2.handleMouseEnter,
          onMouseLeave: _this2.handleMouseLeave,
          "aria-label": "Topic by ".concat(author.name)
        }, (0, _preact.h)(_TopicHeader.default, {
          author: author,
          timestamp: publishedAt,
          isUserLoggedIn: !!currentUser.id,
          menuItems: menuItems,
          actionsToDisplay: actionItems,
          isHovered: isHovered,
          useControlTheme: displayExtendedActions
        }), (0, _preact.h)("header", {
          className: (0, _classnames.default)('topic-info', 'topic__header', 'qa-topic-info'),
          id: "firstpost-title"
        }, (0, _preact.h)(_TopicHeaderLabel.default, {
          topic: topic,
          usePlainTextLabels: usePlainTextLabels,
          stickyOverride: sticky
        }), (0, _preact.h)("h1", {
          className: (0, _classnames.default)('h3', 'topic__title', 'qa-thread-title', {
            'topic__title--translation-in-progress': isTranslationInProgress
          }),
          dangerouslySetInnerHTML: {
            __html: translatedTitle === '' ? title : translatedTitle
          }
        }), (0, _preact.h)(_TopicHeaderMetaInfo.default, {
          views: topic.views,
          totalReplyCount: totalReplyCount,
          publishedAt: publishedAt,
          productAreas: topic.productAreas,
          lastEditedAt: contentType === 'article' ? lastEditedAt : undefined
        })), (0, _preact.h)(_TopicBody.default, {
          topic: topic,
          showEditor: showEditor,
          editor: _this2.renderEditor(),
          pollVotes: pollVotes,
          answeredPoll: answeredPoll,
          displayExtendedActions: displayExtendedActions,
          contentType: contentType,
          poll: poll,
          pollSelectionLoading: pollSelectionLoading,
          handlePollAnswer: _this2.handlePollAnswer,
          onShowAlert: _this2.handleShowAlert,
          onPollUpdate: _this2.onPollUpdate,
          attachmentCdn: attachmentCdn,
          featuredImageSrcSet: topicBodyProps.featuredImageSrcSet,
          featuredImageSizes: topicBodyProps.featuredImageSizes,
          translatedTopicContent: translatedTopicContent === '' ? updatedTopicContent : translatedTopicContent,
          isTranslationInProgress: isTranslationInProgress,
          attachments: updatedAttachments
        }), _common.common.isModuleActive('highlightedBestAnswer') && (0, _preact.h)(_PinnedAndBestAnswerSection.default, {
          authors: authors,
          bestAnswer: bestAnswer !== null && bestAnswer !== void 0 ? bestAnswer : null,
          pinnedReply: pinnedReply !== null && pinnedReply !== void 0 ? pinnedReply : null
        }), (0, _preact.h)(_TopicPublicTags.default, {
          topicId: topicId,
          contentType: contentType,
          tags: tags,
          canEndUserAddPublicTags: topicBodyProps.canEndUserAddPublicTags,
          canUserEdit: (0, _permissions.canLoginUserEditPost)(authorId.toString(), topicId, publishedAt, unlimitedEditPermission),
          onChange: _this2.handleTagsChange,
          usePlainTextLabels: usePlainTextLabels
        }), (0, _preact.h)(_TopicFooter.default, {
          showReplyAction: _this2.props.userHasPermissionToReply,
          onEditorClick: _this2.props.onReplyClick,
          privateId: Number(topicId),
          publicId: publicId,
          likedBy: likedBy,
          contentType: contentType,
          currentUser: currentUser,
          topLikedBy: topLikedBy,
          userSubscribed: userSubscribed,
          showSocialShare: isSocialShareEnabled,
          showFollow: true,
          showVotes: showVotes
        }), (alert === null || alert === void 0 ? void 0 : alert.message) && (0, _preact.h)(_AlertComponent.default, {
          sticky: true,
          messageType: alert.type,
          isVisibleFor: 3000,
          onTimeoutEnd: function onTimeoutEnd() {
            return _this2.setState({
              alert: undefined
            });
          }
        }, alert.message), showReportContentModal && (0, _preact.h)(_ReportContentModal.default, {
          topicTitle: title,
          topicId: Number(topicId),
          contentType: contentType,
          showReportContentModal: _this2.toggleReportedContentModal,
          userId: currentUser.id,
          onShowAlert: _this2.handleShowAlert
        }), showMarkAsSpamModal && (0, _preact.h)(_MarkAsSpamModal.default, {
          title: "frontend_moderation.mark_topic_as_spam",
          subTitle: "frontend_moderation.spam_topic_warning",
          isOpen: showMarkAsSpamModal,
          onClose: function onClose() {
            return _this2.showMarkAsSpamModal(false);
          },
          onMarkAsSpam: _this2.handleMarkAsSpam
        }), showUnmarkMarkAsSpamModal && (0, _preact.h)(_MarkAsNotSpamModal.default, {
          isOpen: showUnmarkMarkAsSpamModal,
          onClose: function onClose() {
            return _this2.toggleUnMarkAsSpamModal(false);
          },
          onToggleSpam: _this2.handleUnmarkAsSpam
        }), showTrashModal && (0, _preact.h)(_TrashModal.default, {
          title: "frontend_moderation.trash_the_topic",
          subTitle: "frontend_moderation.trash_topic_warning",
          isOpen: showTrashModal,
          onClose: function onClose() {
            return _this2.showTrashModal(false);
          },
          onTrash: _this2.handleTrash
        }), showChangeAuthorModal && (0, _preact.h)(_ChangeAuthorModal.default, {
          contentType: contentType,
          topicId: Number(topicId),
          onChangeAuthor: _this2.handleChangeAuthor,
          onClose: function onClose() {
            return _this2.showChangeAuthorModal(false);
          },
          onShowAlert: _this2.handleShowAlert
        }), showReportContentResolveModal && (0, _preact.h)(_ResolveModal.default, {
          reportedContent: reportedContent,
          onResolve: _this2.handleResolve,
          onClose: function onClose() {
            return _this2.toggleReportedContentResolveModal(false);
          },
          topicTitle: title
        }), showCopyTopicModal && categoriesV2 && (0, _preact.h)(_CopyTopicModal.default, {
          topicId: Number(topicId),
          contentType: contentType,
          categoriesV2: categoriesV2,
          onClose: function onClose() {
            return _this2.showCopyTopicModal(false);
          },
          onShowAlert: _this2.handleShowAlert
        }), showMergeIdeaModal && ideaStatuses.length > 0 && (0, _preact.h)(_MergeIdeaModal.default, {
          contentType: contentType,
          fromIdea: {
            id: Number(topic.id),
            title: topic.title,
            publicId: topic.publicId
          },
          fromIdeaStatus: topic.ideaStatus,
          ideaStatuses: ideaStatuses,
          isOpen: showMergeIdeaModal,
          onClose: function onClose() {
            return _this2.showMergeIdeaModal(false);
          },
          onShowAlert: _this2.handleShowAlert
        }), showConvertModal && convertToContentType && (0, _preact.h)(_ConvertTopicModal.default, {
          topicId: Number(topicId),
          publicId: Number(publicId),
          fromContentType: contentType,
          toContentType: convertToContentType,
          onShowAlert: _this2.handleShowAlert,
          hideModal: _this2.hideConvertModal,
          setMessage: function setMessage() {}
        }), showMoveToExistingTopicModal && (0, _preact.h)(_MoveToExistingTopicModal.default, {
          topicId: Number(topicId),
          contentType: contentType,
          moveType: "Move to existing topic",
          onClose: function onClose() {
            return _this2.handleMoveToExistingTopic(false);
          },
          onShowAlert: _this2.handleShowAlert,
          publicId: String(publicId),
          visibleReplyCount: totalReplyCount
        }));
      });
    }
  }]);
  return TopicWrapper;
}(_preact.Component);

var _default = (0, _HubAI.withOnDemandTranslationProps)(TopicWrapper, ['isPostTranslated', 'onDisplayOriginal', 'translatedTitle', 'isTranslationInProgress', 'translatedTopicContent']);

exports.default = _default;
var cssAnchorName = 'topic-view';
exports.cssAnchorName = cssAnchorName;